import React from 'react';

import { HStack, Icon, Text } from '@betterment/samba-react';

export const AccountHighlight: React.FC<{ text: string }> = ({ text }) => (
  <HStack css={{ gap: 'space.100', alignItems: 'center' }}>
    <Icon name="Checkmark" size="small" color="icon" />
    <Text variant="text50" color="text" dangerouslySetInnerHTML={{ __html: text }} />
  </HStack>
);
